import React from 'react';
import PropTypes from 'prop-types';
import { CONFIGURATIONS } from '../constants';

const configurationsSVG = (option, label) => {
  switch (option) {
    case CONFIGURATIONS.AMP_15:
      return (
        <>
          <span>{label.AMP_15}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.AMP_15}</title>
            <path
              className="bg"
              d="m56.58 69.05c-3.81.06-8.68-.22-11.91 2.15-2.58 2-.73 6 2.24 6.4 6.4 1.2 10.32-2.23 9.67-8.55z"
            />
            <path className="bg" d="m156.54 67.45c.05-12.17-18.09-12.17-18 0s18.05 12.17 18 0z" />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-116 41.59h7.3v4.8h.13c2.93-7.42 16.46-7.46 19 .13 3.33-6.82 14.28-7.77 18.72-1.86 1.92 2.62 2.44 6 2.47 9.35v18.3h-7.68v-17.41c.16-3.58-1.51-7.44-5.7-7.16-4.42-.21-6.74 4-6.59 7.93v16.64h-7.71v-18.3c0-3.63-1.31-6.31-5.25-6.27-4.49-.24-7.19 3.67-7.04 7.76v16.81h-7.68zm-34.43 15.07c5-3.7 12-3.43 18-3.48.75-8.33-11-7.92-15.23-3.4l-4-4c5.45-5.56 16-6.7 22.27-2.3 3.44 2.59 4 7.31 3.91 11.2v17.63h-7.02v-4.22h-.19c-3.54 5.86-12.26 6.41-17.55 2.69-4.63-3.11-4.59-10.88-.19-14.12zm48.64 95.69h-4.61v-39.55l-8.1 7.16-2.9-3.46 11.52-9.47h4.09zm39-8c-4.33 11.09-22.36 12-27.13.73l4.54-2c3.42 8 15.09 7.52 18.34-.32a10.9 10.9 0 0 0 -2.34-11.75c-4.61-4.46-12.16-3.29-17.41-.48l.45-23.48h23.1v4.22h-18.52l-.25 13.63c12.96-4.9 24.22 6.6 19.26 19.42zm33.29-57.85v6h-120v-6h91.07v-44.91h7.3v4.61h.13c3.23-5.74 11.41-6.49 16.89-4.13 5.89 2.5 8.92 8.61 8.83 14.88.6 13.72-15.9 22-25.28 11.46h-.19v18.09z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.AMP_30:
      return (
        <>
          <span>{label.AMP_30}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.AMP_30}</title>
            <path
              className="bg"
              d="m116.58 121c-4.83-.27-10.75 3.28-10.75 18.48 0 12.46 2.71 19.92 10.75 19.92 7.68 0 10.75-6.6 10.75-19.92 0-12.15-3.64-18.48-10.75-18.48z"
            />
            <path
              className="bg"
              d="m56.58 69.05c-3.81.06-8.68-.22-11.91 2.15-2.58 2-.73 6 2.24 6.4 6.4 1.2 10.32-2.23 9.67-8.55z"
            />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-116 41.59h7.3v4.8h.13c2.93-7.42 16.46-7.46 19 .13 3.33-6.82 14.28-7.77 18.72-1.86 1.92 2.62 2.44 6 2.47 9.35v18.3h-7.68v-17.41c.16-3.58-1.51-7.44-5.7-7.16-4.42-.21-6.74 4-6.59 7.93v16.64h-7.71v-18.3c0-3.63-1.31-6.31-5.25-6.27-4.49-.24-7.19 3.67-7.04 7.76v16.81h-7.68zm-34.43 15.07c5-3.7 12-3.43 18-3.48.75-8.33-11-7.92-15.23-3.4l-4-4c5.45-5.56 16-6.7 22.27-2.3 3.44 2.59 4 7.31 3.91 11.2v17.63h-7.02v-4.22h-.19c-3.54 5.86-12.26 6.41-17.55 2.69-4.63-3.11-4.59-10.88-.19-14.12zm51 93.06c-7.56 6-21.11 4.2-24.45-5.76l4.88-1.46c1.73 5.84 7.89 7.53 13.44 5.76 6.5-2 8-11.84 2.3-15.49-2.8-1.95-6.61-2.12-10-2v-4.27c3.12.06 6.8 0 9.34-1.89 3.65-2.48 4-9.29.74-12.09-4.1-3.62-12.28-2.29-14.82 3l-4-2c4-7.86 15.17-9.39 21.76-4.13s4.33 16.75-3.78 19.1c9.52 1.8 11.88 15.48 4.6 21.23zm26.5 3.4c-7.64 0-15.37-4.54-15.37-24.15 0-8.92 2.44-22.7 15.37-22.7 10.89 0 15.36 10 15.36 22.43.01 13.38-3.46 24.42-15.35 24.42zm43.43-66.62v6h-120v-6h91.07v-44.91h7.3v4.61h.13c3.23-5.74 11.41-6.49 16.89-4.13 5.89 2.5 8.92 8.61 8.83 14.88.6 13.72-15.9 22-25.28 11.46h-.19v18.09z"
            />
            <path className="bg" d="m156.54 67.45c.05-12.17-18.09-12.17-18 0s18.05 12.17 18 0z" />
          </svg>
        </>
      );
    case CONFIGURATIONS.SINGLE_PHASE:
      return (
        <>
          <span>{label.SINGLE_PHASE}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.SINGLE_PHASE}</title>
            <path
              className="bg"
              d="m100 28.19a71.81 71.81 0 1 0 71.81 71.81 71.89 71.89 0 0 0 -71.81-71.81zm-21.9 94.47h-4.61v-39.56l-8.12 7.17-2.88-3.45 11.51-9.48h4.1zm67-17.63c-2.81 2.84-6 6-10.54 7.06a10.39 10.39 0 0 1 -2 .2c-5.75 0-10.41-4.87-13.9-8.53-.91-.94-1.77-1.84-2.53-2.55l-.1-.09c-2.83-2.84-5.16-4.22-7.11-4.22-2.6 0-5.46 2.5-9.53 6.76l-4.34-4.14c4.47-4.69 8.59-8.57 13.8-8.62 3.7-.05 7.33 1.85 11.43 5.95.89.82 1.8 1.77 2.75 2.77 3.1 3.23 6.94 7.27 10.33 6.6 2.75-.61 5-2.94 7.49-5.41l1.09-1.1 4.22 4.27c-.34.34-.68.69-1.03 1.02z"
            />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-89.5 169.31a79.81 79.81 0 1 1 79.81-79.81 79.9 79.9 0 0 1 -79.81 79.81z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.THREE_PHASE:
      return (
        <>
          <span>{label.THREE_PHASE}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.THREE_PHASE}</title>
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-89.5 169.31a79.81 79.81 0 1 1 79.81-79.81 79.9 79.9 0 0 1 -79.81 79.81z"
            />
            <path
              className="bg"
              d="m100 28.19a71.81 71.81 0 1 0 71.81 71.81 71.89 71.89 0 0 0 -71.81-71.81zm-19.61 91.81c-7.56 6-21.11 4.19-24.45-5.76l4.86-1.48c1.74 5.84 7.89 7.54 13.44 5.76 6.51-2 8-11.84 2.31-15.48-2.8-1.95-6.61-2.12-10-2v-4.25c3.13.06 6.81 0 9.35-1.88 3.65-2.49 4-9.29.73-12.1-4.09-3.62-12.27-2.29-14.81 3l-4-2.05c4-7.86 15.17-9.39 21.76-4.13s4.33 16.76-3.78 19.1c9.48 1.87 11.87 15.54 4.59 21.27zm64.74-15c-2.81 2.84-6 6-10.54 7.06a10.39 10.39 0 0 1 -2 .2c-5.75 0-10.41-4.87-13.9-8.53-.91-.94-1.77-1.84-2.53-2.55l-.1-.09c-2.83-2.84-5.16-4.22-7.11-4.22-2.6 0-5.46 2.5-9.53 6.76l-4.34-4.14c4.47-4.69 8.59-8.57 13.8-8.62 3.7-.05 7.33 1.85 11.43 5.95.89.82 1.8 1.77 2.75 2.77 3.1 3.23 6.94 7.27 10.33 6.6 2.75-.61 5-2.94 7.49-5.41l1.09-1.1 4.22 4.27c-.37.37-.71.72-1.06 1.05z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.PSI_30:
      return (
        <>
          <span>{label.PSI_30}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.PSI_30}</title>
            <path
              className="bg"
              d="m116.58 121c-4.83-.27-10.75 3.28-10.75 18.48 0 12.46 2.71 19.92 10.75 19.92 7.68 0 10.75-6.6 10.75-19.92 0-12.15-3.64-18.48-10.75-18.48z"
            />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-55.23 27h8.07v45.35h-8.07zm-21.21 28.16c-7.42-3.91-14.7-3.33-17.78-10.84-1.82-4.44-.88-12.23 5.61-15.83s16.49-4 23.33 2.07l-5.88 6.2c-3.14-4.32-9.5-4.31-13-2.26-1.69 1-4 5.27-.4 8.26s12.46 3.05 17.09 8.6 3.12 15.79-4.77 20c-6.49 3.5-18.45 3-24.16-4l6.04-5.86c3.06 5 10.39 6.29 14.62 3a5.43 5.43 0 0 0 -.7-9.34zm-57.64-28.12h13c5.55 0 10.29.31 13.91 2.78 7 4.31 6.81 17.4-.38 21.31-5.2 3-12.52 2.47-18.43 2.47v18.75h-8.1zm34.66 122.68c-7.56 6-21.11 4.2-24.45-5.76l4.87-1.46c1.73 5.84 7.89 7.53 13.44 5.76 6.5-2 8-11.84 2.3-15.49-2.8-1.95-6.61-2.12-10-2v-4.27c3.12.06 6.8 0 9.34-1.89 3.65-2.48 4-9.29.74-12.09-4.1-3.62-12.28-2.29-14.82 3l-4-2c4-7.86 15.17-9.39 21.76-4.13s4.33 16.75-3.78 19.1c9.52 1.8 11.88 15.48 4.6 21.23zm26.5 3.4c-7.64 0-15.37-4.54-15.37-24.15 0-8.92 2.44-22.7 15.37-22.7 10.89 0 15.36 10 15.36 22.43 0 13.38-3.47 24.42-15.36 24.42zm43.42-60.62h-120v-6h120z"
            />
            <path
              className="bg"
              d="m78.91 50.61c0-3.1-1.87-6.16-9.08-6.16-2.28 0-4 0-6.34 0v12.73h6.33c7.56-.03 9.09-3.12 9.09-6.57z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.PSI_40:
      return (
        <>
          <span>{label.PSI_40}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.PSI_40}</title>
            <path
              className="bg"
              d="m116.58 121c-4.83-.27-10.75 3.28-10.75 18.48 0 12.46 2.71 19.92 10.75 19.92 7.68 0 10.75-6.6 10.75-19.92 0-12.15-3.64-18.48-10.75-18.48z"
            />
            <path
              className="bg"
              d="m78.91 50.61c0-3.1-1.87-6.16-9.08-6.16-2.28 0-4 0-6.34 0v12.73h6.33c7.56-.03 9.09-3.12 9.09-6.57z"
            />
            <path className="bg" d="m69.47 147.87h15.75v-25.73h-.13z" />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-55.23 27h8.07v45.35h-8.07zm-21.21 28.16c-7.42-3.91-14.7-3.33-17.78-10.84-1.82-4.44-.88-12.23 5.61-15.83s16.49-4 23.33 2.07l-5.88 6.2c-3.14-4.32-9.5-4.31-13-2.26-1.69 1-4 5.27-.4 8.26s12.46 3.05 17.09 8.6 3.12 15.79-4.77 20c-6.49 3.5-18.45 3-24.16-4l6.04-5.86c3.06 5 10.39 6.29 14.62 3a5.43 5.43 0 0 0 -.7-9.34zm-57.64-28.12h13c5.55 0 10.29.31 13.91 2.78 7 4.31 6.81 17.4-.38 21.31-5.2 3-12.52 2.47-18.43 2.47v18.75h-8.1zm40.93 114.56h-6.53v10.75h-4.6v-10.75h-19.59v-5.25l18.31-29.31h5.88v30.33h6.53zm20.23 11.52c-7.64 0-15.37-4.54-15.37-24.15 0-8.92 2.44-22.7 15.37-22.7 10.89 0 15.36 10 15.36 22.43 0 13.38-3.47 24.42-15.36 24.42zm43.42-60.62h-120v-6h120z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.PSI_45:
      return (
        <>
          <span>{label.PSI_45}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.PSI_45}</title>
            <path className="bg" d="m69.47 147.87h15.75v-25.73h-.13z" />
            <path
              className="bg"
              d="m78.91 50.61c0-3.1-1.87-6.16-9.08-6.16-2.28 0-4 0-6.34 0v12.73h6.33c7.56-.03 9.09-3.12 9.09-6.57z"
            />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-55.23 27h8.07v45.35h-8.07zm-21.21 28.16c-7.42-3.91-14.7-3.33-17.78-10.84-1.82-4.44-.88-12.23 5.61-15.83s16.49-4 23.33 2.07l-5.88 6.2c-3.14-4.32-9.5-4.31-13-2.26-1.69 1-4 5.27-.4 8.26s12.46 3.05 17.09 8.6 3.12 15.79-4.77 20c-6.49 3.5-18.45 3-24.16-4l6.04-5.86c3.06 5 10.39 6.29 14.62 3a5.43 5.43 0 0 0 -.7-9.34zm-57.64-28.12h13c5.55 0 10.29.31 13.91 2.78 7 4.31 6.81 17.4-.38 21.31-5.2 3-12.52 2.47-18.43 2.47v18.75h-8.1zm40.93 114.56h-6.53v10.75h-4.6v-10.75h-19.59v-5.25l18.31-29.31h5.88v30.33h6.53zm32.65 2.72c-4.38 11.07-22.36 12-27.13.73l4.54-2a9.71 9.71 0 0 0 11.59 5.51 10.13 10.13 0 0 0 7.56-10.43c-.3-7.81-8.56-13.78-20.52-7.61l.45-23.48h23.1v4.22h-18.59l-.25 13.63c5.91-2 12-1.2 15.87 2.51a15.29 15.29 0 0 1 3.38 16.92zm31-51.82h-120v-6h120z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.PSI_60:
      return (
        <>
          <span>{label.PSI_60}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.PSI_60}</title>
            <path
              className="bg"
              d="m117.7 121c-4.83-.27-10.75 3.28-10.75 18.48 0 12.46 2.71 19.92 10.75 19.92 7.68 0 10.75-6.6 10.75-19.92 0-12.15-3.64-18.48-10.75-18.48z"
            />
            <path
              className="bg"
              d="m78.91 50.61c0-3.1-1.87-6.16-9.08-6.16-2.28 0-4 0-6.34 0v12.73h6.33c7.56-.03 9.09-3.12 9.09-6.57z"
            />
            <path
              className="bg"
              d="m82.11 139.81c-5.19 0-10.12 3.35-10.11 9.79-.17 12.77 20.22 13.39 20.22 0 0-6.34-4.92-9.79-10.11-9.79z"
            />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-55.23 27h8.07v45.35h-8.07zm-21.21 28.16c-7.42-3.91-14.7-3.33-17.78-10.84-1.82-4.44-.88-12.23 5.61-15.83s16.49-4 23.33 2.07l-5.88 6.2c-3.14-4.32-9.5-4.31-13-2.26-1.69 1-4 5.27-.4 8.26s12.46 3.05 17.09 8.6 3.12 15.79-4.77 20c-6.49 3.5-18.45 3-24.16-4l6.04-5.86c3.06 5 10.39 6.29 14.62 3a5.43 5.43 0 0 0 -.7-9.34zm-57.64-28.12h13c5.55 0 10.29.31 13.91 2.78 7 4.31 6.81 17.4-.38 21.31-5.2 3-12.52 2.47-18.43 2.47v18.75h-8.1zm38.32 121c-2.48 2.61-5.42 5-12.11 5-7.36 0-13.4-5.18-14.08-11.71-.64-6.09.81-9.75 3.48-14.1 5-8.05 9.42-15.22 12.49-20.26h5.48l-12.39 19.53.13.13c6.22-3.45 13.69-.8 17 3.4 5.55 7.04 2.45 15.47 0 18.05zm24 5c-7.64 0-15.37-4.54-15.37-24.15 0-8.92 2.44-22.7 15.37-22.7 10.89 0 15.36 10 15.36 22.43-.04 13.46-3.51 24.5-15.4 24.5zm42.26-60.54h-120v-6h120z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.PSI_75:
      return (
        <>
          <span>{label.PSI_75}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.PSI_75}</title>
            <path
              className="bg"
              d="m78.91 50.61c0-3.1-1.87-6.16-9.08-6.16-2.28 0-4 0-6.34 0v12.73h6.33c7.56-.03 9.09-3.12 9.09-6.57z"
            />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-55.23 27h8.07v45.35h-8.07zm-21.21 28.16c-7.42-3.91-14.7-3.33-17.78-10.84-1.82-4.44-.88-12.23 5.61-15.83s16.49-4 23.33 2.07l-5.88 6.2c-3.14-4.32-9.5-4.31-13-2.26-1.69 1-4 5.27-.4 8.26s12.46 3.05 17.09 8.6 3.12 15.79-4.77 20c-6.49 3.5-18.45 3-24.16-4l6.04-5.86c3.06 5 10.39 6.29 14.62 3a5.43 5.43 0 0 0 -.7-9.34zm-57.64-28.12h13c5.55 0 10.29.31 13.91 2.78 7 4.31 6.81 17.4-.38 21.31-5.2 3-12.52 2.47-18.43 2.47v18.75h-8.1zm38.12 84.22-18.24 41.09h-5.19l18.63-41.09h-22.08v-4.22h26.88zm35.46 33.06c-4.38 11.07-22.36 12-27.13.73l4.54-2a9.71 9.71 0 0 0 11.59 5.51 10.13 10.13 0 0 0 7.56-10.43c-.3-7.81-8.56-13.78-20.52-7.61l.45-23.48h23.1v4.22h-18.59l-.25 13.63c5.91-2 12-1.2 15.87 2.51a15.29 15.29 0 0 1 3.38 16.92zm31-51.82h-120v-6h120z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.PSI_100:
      return (
        <>
          <span>{label.PSI_100}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.PSI_100}</title>
            <path
              className="bg"
              d="m78.91 50.61c0-3.1-1.87-6.16-9.08-6.16-2.28 0-4 0-6.34 0v12.73h6.33c7.56-.03 9.09-3.12 9.09-6.57z"
            />
            <path
              className="bg"
              d="m95.59 121c-4.82-.27-10.75 3.28-10.75 18.48 0 12.46 2.71 19.92 10.75 19.92 7.68 0 10.75-6.6 10.75-19.92 0-12.15-3.64-18.48-10.75-18.48z"
            />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-55.23 27h8.07v45.35h-8.07zm-21.21 28.16c-7.42-3.91-14.7-3.33-17.78-10.84-1.82-4.44-.88-12.23 5.61-15.83s16.49-4 23.33 2.07l-5.88 6.2c-3.14-4.32-9.5-4.31-13-2.26-1.69 1-4 5.27-.4 8.26s12.46 3.05 17.09 8.6 3.12 15.79-4.77 20c-6.49 3.5-18.45 3-24.16-4l6.04-5.86c3.06 5 10.39 6.29 14.62 3a5.43 5.43 0 0 0 -.7-9.34zm-57.64-28.12h13c5.55 0 10.29.31 13.91 2.78 7 4.31 6.81 17.4-.38 21.31-5.2 3-12.52 2.47-18.43 2.47v18.75h-8.1zm15.46 125.31h-4.61v-39.55l-8.13 7.16-2.88-3.46 11.52-9.47h4.1zm24.71.77c-7.64 0-15.37-4.54-15.37-24.15 0-8.92 2.44-22.7 15.37-22.7 10.89 0 15.36 10 15.36 22.43.05 13.38-3.46 24.42-15.36 24.42zm35.58 0c-7.64 0-15.37-4.54-15.37-24.15 0-8.92 2.44-22.7 15.37-22.7 10.89 0 15.36 10 15.36 22.43 0 13.38-3.46 24.42-15.36 24.42zm28.83-60.62h-120v-6h120z"
            />
            <path
              className="bg"
              d="m131.17 121c-4.82-.27-10.75 3.28-10.75 18.48 0 12.46 2.71 19.92 10.75 19.92 7.68 0 10.75-6.6 10.75-19.92 0-12.15-3.64-18.48-10.75-18.48z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.PSI_150:
      return (
        <>
          <span>{label.PSI_150}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.PSI_150}</title>
            <path
              className="bg"
              d="m132.13 121c-4.82-.27-10.75 3.28-10.75 18.48 0 12.46 2.71 19.92 10.75 19.92 7.68 0 10.75-6.6 10.75-19.92 0-12.15-3.64-18.48-10.75-18.48z"
            />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-55.23 27h8.07v45.35h-8.07zm-21.21 28.16c-7.42-3.91-14.7-3.33-17.78-10.84-1.82-4.44-.88-12.23 5.61-15.83s16.49-4 23.33 2.07l-5.88 6.2c-3.14-4.32-9.5-4.31-13-2.26-1.69 1-4 5.27-.4 8.26s12.46 3.05 17.09 8.6 3.12 15.79-4.77 20c-6.49 3.5-18.45 3-24.16-4l6.04-5.86c3.06 5 10.39 6.29 14.62 3a5.43 5.43 0 0 0 -.7-9.34zm-57.64-28.12h13c5.55 0 10.29.31 13.91 2.78 7 4.31 6.81 17.4-.38 21.31-5.2 3-12.52 2.47-18.43 2.47v18.75h-8.1zm14.5 125.31h-4.61v-39.55l-8.13 7.16-2.88-3.46 11.52-9.47h4.1zm39-8c-4.38 11.07-22.36 12-27.13.73l4.54-2a9.71 9.71 0 0 0 11.55 5.49 10.14 10.14 0 0 0 7.56-10.43c-.3-7.81-8.56-13.78-20.52-7.61l.45-23.48h23.1v4.22h-18.54l-.25 13.63c5.91-2 11.95-1.2 15.87 2.51a15.29 15.29 0 0 1 3.39 16.91zm23.19 8.8c-7.64 0-15.37-4.54-15.37-24.15 0-8.92 2.44-22.7 15.37-22.7 10.89 0 15.36 10 15.36 22.43.02 13.35-3.47 24.39-15.34 24.39zm27.89-60.65h-120v-6h120z"
            />
            <path
              className="bg"
              d="m78.91 50.61c0-3.1-1.87-6.16-9.08-6.16-2.28 0-4 0-6.34 0v12.73h6.33c7.56-.03 9.09-3.12 9.09-6.57z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.PSI_175:
      return (
        <>
          <span>{label.PSI_175}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.PSI_175}</title>
            <path
              className="bg"
              d="m78.91 50.61c0-3.1-1.87-6.16-9.08-6.16-2.28 0-4 0-6.34 0v12.73h6.33c7.56-.03 9.09-3.12 9.09-6.57z"
            />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-55.23 27h8.07v45.35h-8.07zm-21.21 28.16c-7.42-3.91-14.7-3.33-17.78-10.84-1.82-4.44-.88-12.23 5.61-15.83s16.49-4 23.33 2.07l-5.88 6.2c-3.14-4.32-9.5-4.31-13-2.26-1.69 1-4 5.27-.4 8.26s12.46 3.05 17.09 8.6 3.12 15.79-4.77 20c-6.49 3.5-18.45 3-24.16-4l6.04-5.86c3.06 5 10.39 6.29 14.62 3a5.43 5.43 0 0 0 -.7-9.34zm-57.64-28.12h13c5.55 0 10.29.31 13.91 2.78 7 4.31 6.81 17.4-.38 21.31-5.2 3-12.52 2.47-18.43 2.47v18.75h-8.1zm13.86 125.31h-4.61v-39.55l-8.13 7.16-2.88-3.46 11.52-9.47h4.1zm40.45-41.09-18.24 41.09h-5.19l18.63-41.09h-22.08v-4.22h26.88zm35.44 33.06c-4.38 11.07-22.37 12-27.14.73l4.54-2a9.71 9.71 0 0 0 11.55 5.49 10.14 10.14 0 0 0 7.57-10.43c-.31-7.81-8.57-13.78-20.52-7.61l.44-23.48h23.11v4.22h-18.56l-.26 13.63c5.92-2 11.95-1.2 15.88 2.51a15.3 15.3 0 0 1 3.39 16.94zm14.83-51.82h-120v-6h120z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.PSI_200:
      return (
        <>
          <span>{label.PSI_200}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.PSI_200}</title>
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-55.23 27h8.07v45.35h-8.07zm-21.21 28.16c-7.42-3.91-14.7-3.33-17.78-10.84-1.82-4.44-.88-12.23 5.61-15.83s16.49-4 23.33 2.07l-5.88 6.2c-3.14-4.32-9.5-4.31-13-2.26-1.69 1-4 5.27-.4 8.26s12.46 3.05 17.09 8.6 3.12 15.79-4.77 20c-6.49 3.5-18.45 3-24.16-4l6.04-5.86c3.06 5 10.39 6.29 14.62 3a5.43 5.43 0 0 0 -.7-9.34zm-57.64-28.12h13c5.55 0 10.29.31 13.91 2.78 7 4.31 6.81 17.4-.38 21.31-5.2 3-12.52 2.47-18.43 2.47v18.75h-8.1zm22.66 125.31h-28.8v-5.31c2.33-2.33 5.57-5.82 11-11.28 7.7-7.7 11.56-10.78 12.62-15.68a7.83 7.83 0 0 0 -6.74-9.43c-5.11-.77-10 1.79-10.89 6.95l-4.87-.52c2.23-10.55 12-11.89 18.57-10.14 9.55 2.56 12.33 14.05 3.03 23.56l-17.73 17.62h23.81zm19.69.77c-7.64 0-15.37-4.54-15.37-24.15 0-8.92 2.44-22.7 15.37-22.7 10.89 0 15.36 10 15.36 22.43 0 13.38-3.46 24.42-15.36 24.42zm35.58 0c-7.64 0-15.37-4.54-15.37-24.15 0-8.92 2.44-22.7 15.37-22.7 10.89 0 15.36 10 15.36 22.43 0 13.38-3.46 24.42-15.36 24.42zm26.65-60.62h-120v-6h120z"
            />
            <path
              className="bg"
              d="m78.91 50.61c0-3.1-1.87-6.16-9.08-6.16-2.28 0-4 0-6.34 0v12.73h6.33c7.56-.03 9.09-3.12 9.09-6.57z"
            />
            <path
              className="bg"
              d="m97.77 121c-4.83-.28-10.77 3.27-10.77 18.47 0 12.46 2.71 19.92 10.75 19.92 7.68 0 10.75-6.6 10.75-19.92.02-12.14-3.62-18.47-10.73-18.47z"
            />
            <path
              className="bg"
              d="m133.35 121c-4.82-.27-10.75 3.28-10.75 18.48 0 12.46 2.71 19.92 10.75 19.92 7.68 0 10.75-6.6 10.75-19.92 0-12.15-3.64-18.48-10.75-18.48z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.RECTANGULAR:
      return (
        <>
          <span>{label.RECTANGULAR}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.RECTANGULAR}</title>
            <path
              className="bg"
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
              }}
              d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.9 0 50.9 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.9 0 50.9-10.5 61.5-10.6 10.5-27.6 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.6-10.5-27.6-10.5-61.5z"
            />
            <path d="m41 67h120v65h-120z" fill="#fff" />
          </svg>
        </>
      );
    case CONFIGURATIONS.BIAS_17:
      return (
        <>
          <span>{label.BIAS_17}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.BIAS_17}</title>
            <path
              className="bg"
              style={{ fillRule: 'nonzero' }}
              d="M0,72C0,38.1 0,21.1 10.5,10.5C21.1,0 38.1,0 72,0L128,0C161.9,0 178.9,0 189.5,10.5C200,21.1 200,38.1 200,72L200,128C200,161.9 200,178.9 189.5,189.5C178.9,200 161.9,200 128,200L72,200C38.1,200 21.1,200 10.5,189.5C0,178.9 0,161.9 0,128L0,72Z"
            />
            <path
              style={{ fill: '#fff', fillRule: 'nonzero' }}
              d="M124.7,143.3L26.4,143.3L75.7,56.7L173.6,56.7L124.7,143.3ZM87.436,80.568L84.58,80.568C84.319,82.36 83.88,83.751 83.264,84.74C82.648,85.729 81.883,86.467 80.968,86.952C80.053,87.437 78.971,87.745 77.72,87.876C76.469,88.007 75.079,88.091 73.548,88.128L73.548,90.648L83.908,90.648L83.908,119.768L87.436,119.768L87.436,80.568ZM118.908,81.072L93.708,81.072L93.708,84.32L115.38,84.32C112.655,87.419 110.331,90.387 108.408,93.224C106.485,96.061 104.88,98.889 103.592,101.708C102.304,104.527 101.315,107.411 100.624,110.36C99.933,113.309 99.476,116.445 99.252,119.768L103.06,119.768C103.284,115.213 104.003,111.041 105.216,107.252C106.429,103.463 107.848,100.084 109.472,97.116C111.096,94.148 112.767,91.591 114.484,89.444C116.201,87.297 117.676,85.589 118.908,84.32L118.908,81.072ZM122.324,88.296C122.324,89.416 122.529,90.471 122.94,91.46C123.351,92.449 123.92,93.308 124.648,94.036C125.376,94.764 126.235,95.333 127.224,95.744C128.213,96.155 129.268,96.36 130.388,96.36C131.508,96.36 132.553,96.155 133.524,95.744C134.495,95.333 135.344,94.764 136.072,94.036C136.8,93.308 137.379,92.449 137.808,91.46C138.237,90.471 138.452,89.416 138.452,88.296C138.452,87.176 138.237,86.131 137.808,85.16C137.379,84.189 136.8,83.34 136.072,82.612C135.344,81.884 134.495,81.305 133.524,80.876C132.553,80.447 131.508,80.232 130.388,80.232C129.268,80.232 128.213,80.447 127.224,80.876C126.235,81.305 125.376,81.884 124.648,82.612C123.92,83.34 123.351,84.189 122.94,85.16C122.529,86.131 122.324,87.176 122.324,88.296ZM124.508,88.296C124.508,87.475 124.657,86.709 124.956,86C125.255,85.291 125.675,84.665 126.216,84.124C126.757,83.583 127.383,83.163 128.092,82.864C128.801,82.565 129.567,82.416 130.388,82.416C131.209,82.416 131.975,82.565 132.684,82.864C133.393,83.163 134.019,83.583 134.56,84.124C135.101,84.665 135.521,85.291 135.82,86C136.119,86.709 136.268,87.475 136.268,88.296C136.268,89.117 136.119,89.883 135.82,90.592C135.521,91.301 135.101,91.927 134.56,92.468C134.019,93.009 133.393,93.429 132.684,93.728C131.975,94.027 131.209,94.176 130.388,94.176C128.708,94.176 127.308,93.616 126.188,92.496C125.068,91.376 124.508,89.976 124.508,88.296Z"
            />
          </svg>
        </>
      );
    case CONFIGURATIONS.BIAS_22:
      return (
        <>
          <span>{label.BIAS_22}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.BIAS_22}</title>
            <path
              className="bg"
              style={{ fillRule: 'nonzero' }}
              d="M0,72C0,38.1 0,21.1 10.5,10.5C21.1,0 38.1,0 72,0L128,0C161.9,0 178.9,0 189.5,10.5C200,21.1 200,38.1 200,72L200,128C200,161.9 200,178.9 189.5,189.5C178.9,200 161.9,200 128,200L72,200C38.1,200 21.1,200 10.5,189.5C0,178.9 0,161.9 0,128L0,72Z"
            />
            <path
              style={{ fill: 'white', fillRule: 'nonzero' }}
              d="M124.7,143.3L26.4,143.3L75.7,56.7L173.6,56.7L124.7,143.3ZM93.456,119.768L93.456,116.52L71.672,116.52C71.896,115.213 72.456,114.009 73.352,112.908C74.248,111.807 75.284,110.789 76.46,109.856C77.636,108.923 78.859,108.073 80.128,107.308C81.397,106.543 82.499,105.843 83.432,105.208C84.739,104.387 85.98,103.5 87.156,102.548C88.332,101.596 89.377,100.56 90.292,99.44C91.207,98.32 91.935,97.088 92.476,95.744C93.017,94.4 93.288,92.907 93.288,91.264C93.288,89.435 92.98,87.829 92.364,86.448C91.748,85.067 90.889,83.919 89.788,83.004C88.687,82.089 87.399,81.399 85.924,80.932C84.449,80.465 82.853,80.232 81.136,80.232C79.008,80.232 77.151,80.577 75.564,81.268C73.977,81.959 72.661,82.92 71.616,84.152C70.571,85.384 69.796,86.849 69.292,88.548C68.788,90.247 68.555,92.104 68.592,94.12L72.12,94.12C72.083,92.664 72.223,91.283 72.54,89.976C72.857,88.669 73.371,87.512 74.08,86.504C74.789,85.496 75.713,84.693 76.852,84.096C77.991,83.499 79.363,83.2 80.968,83.2C82.163,83.2 83.292,83.377 84.356,83.732C85.42,84.087 86.353,84.609 87.156,85.3C87.959,85.991 88.593,86.831 89.06,87.82C89.527,88.809 89.76,89.939 89.76,91.208C89.76,92.776 89.489,94.129 88.948,95.268C88.407,96.407 87.595,97.517 86.512,98.6C85.429,99.683 84.207,100.7 82.844,101.652C81.481,102.604 80.109,103.537 78.728,104.452C77.347,105.367 76.003,106.319 74.696,107.308C73.389,108.297 72.213,109.389 71.168,110.584C70.123,111.779 69.283,113.123 68.648,114.616C68.013,116.109 67.677,117.827 67.64,119.768L93.456,119.768ZM124.592,119.768L124.592,116.52L102.808,116.52C103.032,115.213 103.592,114.009 104.488,112.908C105.384,111.807 106.42,110.789 107.596,109.856C108.772,108.923 109.995,108.073 111.264,107.308C112.533,106.543 113.635,105.843 114.568,105.208C115.875,104.387 117.116,103.5 118.292,102.548C119.468,101.596 120.513,100.56 121.428,99.44C122.343,98.32 123.071,97.088 123.612,95.744C124.153,94.4 124.424,92.907 124.424,91.264C124.424,89.435 124.116,87.829 123.5,86.448C122.884,85.067 122.025,83.919 120.924,83.004C119.823,82.089 118.535,81.399 117.06,80.932C115.585,80.465 113.989,80.232 112.272,80.232C110.144,80.232 108.287,80.577 106.7,81.268C105.113,81.959 103.797,82.92 102.752,84.152C101.707,85.384 100.932,86.849 100.428,88.548C99.924,90.247 99.691,92.104 99.728,94.12L103.256,94.12C103.219,92.664 103.359,91.283 103.676,89.976C103.993,88.669 104.507,87.512 105.216,86.504C105.925,85.496 106.849,84.693 107.988,84.096C109.127,83.499 110.499,83.2 112.104,83.2C113.299,83.2 114.428,83.377 115.492,83.732C116.556,84.087 117.489,84.609 118.292,85.3C119.095,85.991 119.729,86.831 120.196,87.82C120.663,88.809 120.896,89.939 120.896,91.208C120.896,92.776 120.625,94.129 120.084,95.268C119.543,96.407 118.731,97.517 117.648,98.6C116.565,99.683 115.343,100.7 113.98,101.652C112.617,102.604 111.245,103.537 109.864,104.452C108.483,105.367 107.139,106.319 105.832,107.308C104.525,108.297 103.349,109.389 102.304,110.584C101.259,111.779 100.419,113.123 99.784,114.616C99.149,116.109 98.813,117.827 98.776,119.768L124.592,119.768ZM128.232,88.296C128.232,89.416 128.437,90.471 128.848,91.46C129.259,92.449 129.828,93.308 130.556,94.036C131.284,94.764 132.143,95.333 133.132,95.744C134.121,96.155 135.176,96.36 136.296,96.36C137.416,96.36 138.461,96.155 139.432,95.744C140.403,95.333 141.252,94.764 141.98,94.036C142.708,93.308 143.287,92.449 143.716,91.46C144.145,90.471 144.36,89.416 144.36,88.296C144.36,87.176 144.145,86.131 143.716,85.16C143.287,84.189 142.708,83.34 141.98,82.612C141.252,81.884 140.403,81.305 139.432,80.876C138.461,80.447 137.416,80.232 136.296,80.232C135.176,80.232 134.121,80.447 133.132,80.876C132.143,81.305 131.284,81.884 130.556,82.612C129.828,83.34 129.259,84.189 128.848,85.16C128.437,86.131 128.232,87.176 128.232,88.296ZM130.416,88.296C130.416,87.475 130.565,86.709 130.864,86C131.163,85.291 131.583,84.665 132.124,84.124C132.665,83.583 133.291,83.163 134,82.864C134.709,82.565 135.475,82.416 136.296,82.416C137.117,82.416 137.883,82.565 138.592,82.864C139.301,83.163 139.927,83.583 140.468,84.124C141.009,84.665 141.429,85.291 141.728,86C142.027,86.709 142.176,87.475 142.176,88.296C142.176,89.117 142.027,89.883 141.728,90.592C141.429,91.301 141.009,91.927 140.468,92.468C139.927,93.009 139.301,93.429 138.592,93.728C137.883,94.027 137.117,94.176 136.296,94.176C134.616,94.176 133.216,93.616 132.096,92.496C130.976,91.376 130.416,89.976 130.416,88.296Z"
            />
          </svg>
        </>
      );
    default:
      return null;
  }
};

const Configuration = ({ options, label, themeColour }) => (
  <div className="product-options">
    {options.map(option => (
      <div className={`option ${themeColour}`} key={option}>
        {configurationsSVG(option, label)}
      </div>
    ))}
  </div>
);

Configuration.defaultProps = {
  options: [],
  label: {},
  themeColour: '',
};

Configuration.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.shape({
    common: PropTypes.instanceOf(Object),
  }),
  themeColour: PropTypes.string,
};

export default Configuration;
